import { RequestDemo } from "@stories/pages/Home/RequestDemo";

export const DemoView = () => {
  return <RequestDemo />;
};
